/**
 * Creado por Norte70
 * @author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 10/12/2020
 */
const procedureTaskStepsRequest = () => {
    return {
        taskId: 0,
        stageId: 0
    }

}

export default procedureTaskStepsRequest